import { Base64 } from "./Base64";

export class AmmoLoader {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static loadAmmoAsync(doneCallback: Function, callbackCtx: any): void {
        // Je WebAssembly podporovane?
        if (AmmoLoader.isWasmSupported) {
            // Nacist glue js file pro Ammo
            AmmoLoader.loadScriptAsync("./lib/ammo.wasm.js", (): void => {
                // Nacist kod pro Ammo webassembly modul jak textovy soubor s base64 binarnimi daty
                let xhr = new XMLHttpRequest();

                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4) {
                        let res = false;

                        switch (xhr.status) {
                            case 0: {
                                if (xhr.responseURL && xhr.responseURL.startsWith('file:///')) {
                                    res = true;
                                    break;
                                }
                            }
                            case 200:
                            case 201:
                            case 206:
                            case 304: {
                                res = true;
                                break;
                            }
                        }

                        if (res) {
                            // Prevest base64 na binarni data
                            let buf = Base64.decode(xhr.responseText);

                            // Instatiate Ammo webassembly
                            let lib = (<any>window)["Ammo"];

                            lib({ locateFile: (): ArrayBuffer => { return buf; } }).then((instance: any) => {
                                (<any>window)["Ammo"] = instance;
                                doneCallback.call(callbackCtx);
                            });
                        }
                        else {
                            console.log("failed to load: Ammo.wasm.txt");
                        }
                    }
                };
                xhr.open("GET", "lib/ammo.wasm.txt");
                xhr.withCredentials = false;
                xhr.responseType = "text";
                xhr.send();
            });
        }
        else {
            // Nacist klasicky Ammo.js
            AmmoLoader.loadScriptAsync("lib/ammo.js", (): void => {
                (<any>window)["Ammo"]({ locateFile: (): string => { return ""; } }).then((instance: any) => {
                    (<any>window)["Ammo"] = instance;
                    doneCallback.call(callbackCtx);
                });
            });
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Check for wasm module support
     */
    //-------------------------------------------------------------------------
    private static isWasmSupported(): boolean {
        try {
            if (typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function") {
                const module = new WebAssembly.Module(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));

                if (module instanceof WebAssembly.Module)
                    return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
            }
        }
        catch (e) {
        }

        return false;
    }

    //-------------------------------------------------------------------------
    /**
     * Load a script
     * @param url
     * @param doneCallback 
     */
    //-------------------------------------------------------------------------
    private static loadScriptAsync(url: string, doneCallback: () => void) {
        let tag = document.createElement('script');

        tag.onload = () => { doneCallback(); }
        tag.onerror = () => { throw new Error('failed to load: ' + url); }
        tag.async = true;
        tag.src = url;

        document.head.appendChild(tag);
    }
}